import React, { useCallback, useEffect, useRef, useState } from 'react'
import styles from './style.module.css';
import styles2 from '../../../table-list/style.module.css';

import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../../../design-system/lib/Modal';
import Typography from '../../../../../design-system/lib/Typography';
import DropDown from '../../../../../design-system/lib/DropDown';
import { ADD_SQUARE, EDIT, Edit, ROUTE_OPTIMIZE, Routes_deactive, Status, QUESTION, INFO_CIRCLE, INFO_CIRCLE_DARK, SEARCH_NOT_FOUND, FLAG, CLOSE_DARK, DRIVER } from '../../../../../assets';
import Button from '../../../../../design-system/lib/Button';
import { RouteApi } from '../../../../../service/API/route';
import { OrderApi } from '../../../../../service/API/order';
import { get_id } from '../../../../../helper/UserData/userdate';
import { snack } from '../../../../../utils/SnackbarUtilsConfigurator';
import TableAddRoute from '../addRoute';
import clsx from 'clsx';
import { Table_ClearSelectedOrders } from '../../../../../Redux/actions/actionNames';
import { DispatcherApi } from '../../../../../service/API/dispatcher';
import item from '../../../../../Entries/Main/components/ViewOrder/components/event_TimeLine/listEvent/item';
import { removeNull } from '../../../../main/driver-list';
import Switch from '../../../../../design-system/lib/Switch';
import { LearnMore } from '../../../../learnMore';
import { useTranslation } from 'react-i18next';
import IconProvider from '../../../../../design-system/lib/IconProvider';
import InputSerachFilter from '../../../../../design-system/lib/InputSerachFilter';
import SearchList from '../../../../../design-system/lib/SearchList';
import { debounce, isEmpty } from 'lodash';
import Tag from '../../../../../design-system/lib/Tag';
import { GetUserAccess } from '../../../../../helper/module';



const statusWithSource = [{ status: "PickupFailed", type: "PickupFailure", source: null },
{ status: "NotDelivered", type: "DeliveryFailure", source: null },
{ status: "CustomerCanceled", type: "Cancellation", source: "customer" }

]


function TableEditStatusSelectedOrders() {
  const selectedOrders = useSelector((state) => state.Table.selectedOrders)
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [routesList, setRoutesList] = useState([]);
  const [routesListLOading, setRoutesListLOading] = useState(false);

  const [openEditStatus, setOpenEditStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAddRoute, setShowAddRoute] = useState(false);
  const [failureReasonsList, setFailureReasonsList] = useState([]);
  const [selectedFailureReason, setSelectedFailureReason] = useState(null);
  const [tabs, setTabs] = useState(0);
  const { t, i18n } = useTranslation();
  const [routeSearch, setRouteSearch] = useState("");
  const [SearchListState, setSearchListState] = useState(false);
  const dispatch = useDispatch();


  const getRoutesListWithName = React.useCallback(() => {

    (!isEmpty(routeSearch)) &&
      (async () => {
        let Route = new RouteApi()
        let data = await Route.getRoutesList(
          { name: routeSearch }
        )
        setRoutesList(data)
            setRoutesListLOading(false)

      })();

    if (isEmpty(routeSearch)) {
      (async () => {
        let Route = new RouteApi()
        let data = await Route.getRoutesList(
          { status: ['Unassigned', 'Assigned', 'Started'] }
        )
        setRoutesList(data)
        setRoutesListLOading(false)

      })();

    }



  }, [routeSearch]);


  const debouncedChangeHandler = useCallback(
    debounce(getRoutesListWithName, 600)
    , [routeSearch]);

  const handleEditStatus = React.useCallback(async () => {

    if (!openEditStatus) {
      setRoutesList([])
      setSelectedRoute(null)
      setSelectedStatus(null)
      setOpenEditStatus(!openEditStatus)

    } else {
      setOpenEditStatus(!openEditStatus)
    }

    let Route = new RouteApi()
    let data = await Route.getRoutesList(
      { status: ['Unassigned', 'Assigned', 'Started'] }
    )
    setRoutesList(data)

  }, [openEditStatus]);



  function handleAddRote(e, route) {
    setShowAddRoute(e)

    if (route) {
      setSelectedRoute(route)
    }
  }




  const getRouteList = React.useCallback(async () => {

    let Route = new RouteApi()
    let data = await Route.getRoutesList(
        {status : ['Unassigned' , 'Assigned' , 'Started' ]}
      )
    setRoutesList(data)

  }, [showAddRoute]);


  const canSelectFaildReason = React.useCallback(() => {

    let index = statusWithSource.map((item) => { return item.status }).indexOf(selectedStatus?.title)
    if (index > -1) {
      return true
    } else {

      return false
    }

  }, [selectedStatus]);


  useEffect(() => {

    (async () => {

      let index = statusWithSource.map((item) => { return item.status }).indexOf(selectedStatus?.title)

      if (index > -1) {
        setFailureReasonsList([])
        let Dispatcher = new DispatcherApi()
        let dataP = await Dispatcher.FailureReason(removeNull({ type: statusWithSource[index].type, source: statusWithSource[index].source }))
        if (dataP) {
          setFailureReasonsList(dataP)

        }
      } else {
        setFailureReasonsList([])


      }
    })();



  }, [selectedStatus])



  const handleSave = React.useCallback(async () => {
    
    setLoading(true)
    let Order = new OrderApi()
    try {
      let data = await Order.BatchUpdateStatus({
        "ids": Object.keys(selectedOrders),
        "status": selectedStatus.title,
        "dispatcherId": get_id(),
        "routeId": (["PickupFailed" ,"NotDelivered" ,"AtDeliveryServicePoint" ].indexOf(selectedStatus.title) > -1) ? (tabs == 0 ? undefined : (tabs == 1 ? selectedRoute?.id : null )) : selectedRoute?.id,
        ...(selectedFailureReason && { failureReasonId: String(selectedFailureReason.id), failureReasonText: selectedFailureReason.text })
      })


      if (data) {
        setLoading(false)
        setOpenEditStatus(false)
        snack.BatchOperationalSnackbar(JSON.stringify({
          "id": data.id,
          "status": data.status,
          "action": data.action,
          "totalRecordsCount": data.totalRecordsCount,
          "successfulRecordsCount": data.successfulRecordsCount,
          "failedRecordsCount": data.failedRecordsCount,
          "lastProcessedRecordIndex": data.lastProcessedRecordIndex,
          "records": data.records,
          "createdAt": data.createdAt,
          "doneAt": data.doneAt,
        }))
        dispatch(Table_ClearSelectedOrders())

      } else {
        setLoading(false)
      }

    } catch (error) {

      snack.error_i18("tryagain")
      setLoading(false)

    }



  }, [selectedStatus, selectedRoute, selectedOrders, selectedFailureReason , tabs]);


  const hasDriverAssignError = React.useCallback(() => {

    if (selectedStatus && selectedStatus.route && selectedRoute) {
      if (selectedStatus.driver && !selectedRoute.driver) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }


  }, [selectedStatus, selectedRoute]);

  const getRoutesList = React.useCallback(() => {

    if(String(routeSearch).trim().length > 0) {
      var PATTERN = String(routeSearch).toLowerCase().trim(),
      filtered = routesList.filter(function (str) { return String(str.name).toLowerCase().includes(PATTERN)  });
      return filtered
    }else{
      return routesList
    }

  }, [routeSearch , routesList]);

  const hasRouteAssignError = React.useCallback(() => {


    if (selectedStatus && selectedStatus.route && selectedRoute) {
      if (!selectedStatus.driver && !!selectedRoute.driver) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }

  }, [selectedStatus, selectedRoute]);

  // useEffect(async () => {
  //   let Route = new RouteApi()
  //   let data = await Route.getRoutesList()
  //   setRoutesList(data)
  // }, [])

  // useEffect(async () => {

  // }, [openEditStatus])

  useEffect(() => {
  (!routesList || isEmpty(routesList)) &&
    (async () => {
      let Route = new RouteApi()
      let data = await Route.getRoutesList(
        {status : ['Unassigned' , 'Assigned' , 'Started' ]}
      )
      setRoutesList(data)
    })();
  }, [showAddRoute]);

 useEffect(() => {
      setRoutesListLOading(true)

  debouncedChangeHandler()
  }, [routeSearch]);




  const geneRoutes = getRoutesList();
 
  return (
    <>
     {GetUserAccess().editStatus_PickupDelivery?.length > 0 && <Button size='Medium' type='Secondary' text={t('Edit Status')} icon={Edit} onClick={() => { handleEditStatus() }} />}
      {(openEditStatus && !showAddRoute) && <Modal HeaderExtraBtn={<LearnMore  hastext={false} placement={"bottomEnd"} where='PickupDeliveryEditStatus' />} ConfirmationLoading={loading} ConfirmationDisabled={((!selectedStatus || (selectedStatus?.route ? selectedRoute == null : false)) || (hasDriverAssignError() || hasRouteAssignError()) || (canSelectFaildReason() ? !selectedFailureReason : false) || ( selectedStatus ? (["PickupFailed" ,"NotDelivered" ,"AtDeliveryServicePoint" ].indexOf(selectedStatus.title) > -1 && tabs == 1 && !selectedRoute) : false))} size='Large' title={t('Edit Status')} ConfirmationText='Save' onclose={() => { handleEditStatus() }} ConfirmationOnClick={() => { handleSave() }}

        body={<div className={styles.bodyContainer}>
          <div className={styles.firstRow}>
            <span className={styles.P_Hub_D}> <Typography weight='Body_Small_Bold' textColor='TextDark' text={t('P_Hub_D')} /> </span>
            <GetGroups selectedOrders={selectedOrders} />
          </div>

          <div className={styles.divider} />

          <DropDown placement='bottomStart' icon={Status} size='Medium' data={GetStatusList()} text={selectedStatus ? t(selectedStatus.title) : t('Select Status')} onClick={item => {
            setSelectedStatus(item)
            setSelectedFailureReason(null)
            setFailureReasonsList([])

          }} className={styles.DropDown} checkSelected='full' />

          {(selectedStatus ? selectedStatus.route : false) && <Typography weight='Body_Middle_Regular' textColor='TextDark' text={<> <IconProvider Icon={INFO_CIRCLE_DARK} /> {selectedStatus.driver ? t("EDROPANDDE1") : t("EDROPANDDE2")} </>} className={styles.error} />}

          {(canSelectFaildReason() && failureReasonsList.length > 0) && <DropDown style={{ marginTop: "12px" }} placement='bottomStart' icon={QUESTION} size='Medium' data={failureReasonsList.map((item) => { return { ...item, title: item.text } })} text={selectedFailureReason ? selectedFailureReason.title : 'Select Reason'} onClick={item => {
            setSelectedFailureReason(item)
          }} className={styles.DropDown} checkSelected='full' />}

          {(selectedStatus && selectedStatus.route && !selectedRoute) && <>
          
          <div className={styles.divider} />

          <div className={styles.firstRow} style={{maxHeight:"36px"}}>
            <span className={styles.P_Hub_D} style={{border:"none" , marginBottom:"8px"}}> <Typography weight='Body_Small_Bold' textColor='TextDark' text='Route' /> </span>
          </div>
            <div className={styles.firstRow} style={{flexWrap:"wrap",maxHeight:"51px"}}>
              
              {/* <DropDown placement='bottomStart' icon={ROUTE_OPTIMIZE} size='Medium' data={GetStatusList()} text={selectedRoute ? selectedRoute.name : 'Select Route'} onClick={item => {
                setSelectedStatus(item)
              }} className={styles.RouteDropDown} checkSelected='full' ItemsList={ItemsList(routesList, selectedRoute, setSelectedRoute)} /> */}

          <SearchList handleIsOpen={(val)=>{setSearchListState(val)}} onChange={(e)=>{ setRouteSearch(e?.target?.value ? e?.target?.value : "")}} style={{ zIndex: "1" }} value={routeSearch} placeHolder={t("Searchandselectroute")} isloading={routesListLOading} 
          listItemOnclick={setSelectedRoute} error={false} errorDescription={""} errorTitle={""} errorIcon={null}
              ListItemChildren={(data)=>{ return RouteItem(data , selectedStatus)}} noResult={geneRoutes.length > 0  ? false : true} noResultIcon={Routes_deactive} noResultTitle={t("NoRoutes")} noResultDescription={t("Addroutestobeabletosearchandselectroute")} noResultActionTitle='Add Route'  noResultActionOnClick={() => { setShowAddRoute(true) }} list={(geneRoutes && geneRoutes.length > 0) ? geneRoutes : null } inputIcon={<IconProvider Icon={ROUTE_OPTIMIZE}  size='16'/>} containerClassName={styles.end}
            />
              {/* <Button size='Medium' type='Secondary' icon={EDIT} style={{ marginInlineStart: "10px", paddingTop: "9px", paddingBottom: "9px" }} onClick={() => { }} /> */}
{(GetUserAccess().loaded && GetUserAccess().newRoute) && <Button size='Medium' type='Secondary' icon={ADD_SQUARE} text='Add Route' style={{ marginInlineStart: "10px", paddingTop: "9px", paddingBottom: "9px" }} onClick={() => { setShowAddRoute(true) }} />
}              {(String(routeSearch).trim().length > 0 && !SearchListState) && <Typography text={t("Pleaseselectroutefromsearchresults")} weight='Body_Small_Regular' style={{color:"red" ,width:"100%"}}/>}

            </div>

            </>}

            {selectedRoute && <><div className={styles.divider} />
            
            <div className={styles.selectedRoute}>
              <IconProvider Icon={Routes_deactive} size='16' />

                <div style={{display:"flex",flexDirection:"column" ,justifyContent:"center" ,alignItems:"cneter" ,gap:"2px"}}>
                  <Typography weight='Body_Middle_Medium' text={selectedRoute.name} />
                  <Typography weight='Body_Tiny_Regular' text={selectedRoute?.status} />

                  {/* <Typography weight='Body_Tiny_Regular' text={selectedRoute.driver ? selectedRoute.driver?.name : "Unassigned"} /> */}

                </div>
                {selectedRoute.driver  && <Tag color='TextDark' backgroundColor='GrayUltraLight' size='Small' weight='Body_Tiny_Regular' icon={DRIVER} text={selectedRoute.driver?.name}  style={{marginInlineStart:"6px"}} />}

  <Button size='Medium' type='Secondary' icon={CLOSE_DARK} onClick={()=>{
                  setSelectedRoute(null)
                }}  style={{marginInlineStart:"auto",cursor:"pointer"}} />
            </div>
            
            </>}

            {(selectedStatus && selectedStatus.tabs) && <>
              <div className={styles.divider} />
              <Switch items={[t("Don’t change routes"),t("Edit routes"),t("Remove routes")]} index={tabs} handleSelection={(i)=>{setTabs(i)}} />
              { tabs == 1 &&
                <div className={styles.tabRouteContainer}>
                <DropDown style={{flex:"1"}} placement='bottomStart' icon={ROUTE_OPTIMIZE} size='Medium' data={GetStatusList()} text={selectedRoute ? selectedRoute.name : t('Select Route')} onClick={item => {
                setSelectedStatus(item)
              }} className={styles.RouteDropDown} checkSelected='full' ItemsList={ItemsList(routesList, selectedRoute, setSelectedRoute)} />
              {/* <Button size='Medium' type='Secondary' icon={EDIT} style={{ marginInlineStart: "10px", paddingTop: "9px", paddingBottom: "9px" }} onClick={() => { }} /> */}
             {(GetUserAccess().loaded && GetUserAccess().newRoute) && <Button size='Medium' type='Secondary' icon={ADD_SQUARE} text={t('Add Route')} style={{ marginInlineStart: "10px", paddingTop: "9px", paddingBottom: "9px" }} onClick={() => { setShowAddRoute(true) }} />}
                </div>
              }
      </>}
         
        </div>} />}




      {showAddRoute && <TableAddRoute onClose={handleAddRote} />}

    </>

  )
}


export default TableEditStatusSelectedOrders




function ItemsList(data, selectedRoute, setSelectedRoute) {
  return (
    <div className={styles.itemsConatiner}>
      {data.map((route) => {
        return <div onClick={() => { setSelectedRoute(route) }}>

          <img src={Routes_deactive} />
          <Typography weight={selectedRoute?.id == route.id ? "Body_Middle_Bold" : 'Body_Middle_Regular'} textColor='TextNormal' text={route.name} className={styles.itemName} />
          <Typography weight='Body_Small_Regular' textColor='TextLight' text={route.driver ? route.driver?.name : "Unassigned"} className={styles.itemDriverName} />

        </div>
      })}
    </div>
  )
}

function groupBy(array, key) {
  return array.reduce((result, currentValue) => {
    // برای گروه‌بندی بر اساس کلید مشخص شده
    const groupKey = currentValue[key];
    if (!result[groupKey]) {
      result[groupKey] = [];
    }
    result[groupKey].push(currentValue);
    return result;
  }, {});
}


function GetGroups({ selectedOrders }) {

  // var objectToArray = Object.keys(selectedOrders).map((key) => selectedOrders[key]);

  // const result = Object.groupBy(objectToArray, ({ status }) => status);

  var objectToArray = Object.keys(selectedOrders).map((key) => selectedOrders[key]);

  const result = groupBy(objectToArray, 'status'); // استفاده از تابع groupBy

  return (
    <div className={styles.groupStatus}>

      {Object.keys(result).map((group) => {
        return <div className={clsx(styles.groupStatusdiv, styles2[group])}>
          <Typography weight='Body_Small_Medium' textColor='TextDark' text={group} />
          <span className={styles.groupStatusspan}>
            <Typography weight='Body_Tiny_Bold' textColor='TextDark' text={result[group].length} />
          </span>
        </div>
      })}


    </div>
  )
}


export const GetStatusList = () => {
  
    const access = GetUserAccess().editStatus_PickupDelivery;

  
  const fullList = [
  {
    title: "Draft",
    stage: "P",
    driver: false,
    route: false
  },
  {
    title: "Confirmed",
    stage: "P",
    driver: false,
    route: false
  },
  {
    title: "AtPickupServicePoint",
    stage: "P",
    driver: false,
    route: false
  },
  {
    title: "PickupRouted",
    stage: "P",
    driver: false,
    route: true
  },
  {
    title: "ReadyForPickup",
    stage: "P",
    driver: true,
    route: true
  },
  {
    title: "PickedUp",
    stage: "P",
    driver: true,
    route: true
  },
  {
    title: "AtWarehouse",
    stage: "D",
    driver: false,
    route: false
  },
  {
    title: "DeliveryRouted",
    stage: "D",
    driver: false,
    route: true
  },
  {
    title: "ReadyForDelivery",
    stage: "D",
    driver: true,
    route: true
  },
  {
    title: "OutForDelivery",
    stage: "D",
    driver: true,
    route: true
  },
  {
    title: "AtDeliveryServicePoint",
    stage: "D",
    driver: false,
    route: false,
    tabs: true
  },
  {
    title: "Delivered",
    stage: "D",
    driver: true,
    route: true
  },
  {
    title: "NotDelivered",
    stage: "D",
    driver: false,
    route: false,
    tabs: true
  },
  {
    title: "ForReturn",
    stage: "D",
    driver: false,
    route: false
  },
  {
    title: "Returned",
    stage: "D",
    driver: false,
    route: false
  },
  {
    title: "CustomerCanceled",
    stage: null,
    driver: false,
    route: false
  },
  {
    title: "PickupFailed",
    stage: "P",
    driver: false,
    route: false,
    tabs: true
  },


  {
    title: "SupportCanceled",
    stage: null,
    driver: false,
    route: false
  }, {
    title: "Lost",
    stage: null,
    driver: false,
    route: false
  },
]


  return fullList.filter(item => access.includes(item.title));

  
}


function RouteItem({data , onclick } , selectedStatus) {

   let stylee ={
    maxWidth: '324px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color:"rgba(128, 128, 128, 1)"
  }
  return (
    <div className={styles.CustomerListItemContainer} onClick={onclick && (Boolean(selectedStatus.driver) == Boolean(data.driver) ) ? onclick : null} style={{opacity : (Boolean(selectedStatus.driver) == Boolean(data.driver) ) ? "1" :".4", cursor : (Boolean(selectedStatus.driver) == Boolean(data.driver) ) ? "pointer" :"not-allowed"}}>
        <IconProvider Icon={Routes_deactive} size='16' />

        <div className={styles.namePhoneContainer}>


        <span className={styles.secondLineConatiner}>   
          <Typography weight='Body_Tiny_Medium' text={data.name} style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',...stylee , color :"rgba(36, 36, 36, 1)"
        }}/>
         { data.driver && <Typography weight='Body_Tiny_Regular' text={data.driver?.name} style={{...stylee , color : "rgba(84, 84, 84, 1)"}} />}
        </span>

        <Typography weight='Body_Tiny_Regular' text={data?.status} style={stylee} />

        </div>
    </div>
  )
}